//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { faAngleDown, faPencil } from '@fortawesome/pro-regular-svg-icons';
import ArtistAvatar from '@motionelements/core/src/components/member/ArtistAvatar.vue';

export default {
  name: 'hero-aside',
  components: {
    ArtistAvatar,
    ButtonFollow: () => import('@motionelements/core/src/components/ui/buttons/ButtonFollowArtist.vue'),
    SnsCard: () => import('@motionelements/core/src/components/artist/cards/SnsCard.vue'),
    ToolsCard: () => import('@motionelements/core/src/components/artist/cards/ToolsCard.vue'),
    HeroAsideList: () => import('@motionelements/core/src/components/artist/sections/HeroAsideList.vue'),
  },
  props: {
    artist: {
      type: Object,
      required: true,
    },
    hideFollow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      faAngleDown,
      faPencil,
      isExpanded: false,
    };
  },
  computed: {
    ...mapState({
      username: state => _.get(state.user.member, 'username'),
    }),
    description() {
      return _.get(this.artist, 'description');
    },
    showExpandButton() {
      return this.description || _.get(this.artist, 'sns', []).length || _.get(this.artist, 'tools', []).length;
    },
    artistUsername() {
      return _.get(this.artist, 'username');
    },
    isProfileOwner() {
      return this.artistUsername === this.username;
    },
  },
};
